import React from 'react';
import {Box, Grid, TextField, Typography, Button, List, ListItem, Avatar, LinearProgress} from "@mui/material";
import swal from "sweetalert";
// import {manageChatCompletions, createChatSession, updateChatSessionSystemPrompts} from '../../utilityFunctions/WellnessUtil';
import {manageReportChatFlow, createReportChatSession, updateChatSessionSystemPrompts, executeReportPipeline, getPipelineStatus, approvePipelineCheckpoint, submitPipelineAnswer} from '../../utilityFunctions/WellnessUtil';
import HitlReviewPanel from './HitlReviewPanel';
import Colors from "../../components/ui/Colors";
import CustomLoader from "../../components/CustomLoader";
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import MicIcon from '@mui/icons-material/Mic';
import StopIcon from '@mui/icons-material/Stop';
import PersonIcon from '@mui/icons-material/Person';
import AssessmentIcon from '@mui/icons-material/Assessment';
import { useAudioStream } from '../speechai/useAudioStream';
import { useHistory } from "react-router-dom";

const newSessionRequest={};
const completionsRequest={};
const reportRequest={};

export default function LlmReportAgent(props) {
    
    const { loginUser } = props;
    const history = useHistory();
    const [loading, setLoading] = React.useState(false);
    const [chatLoading, setChatLoading] = React.useState(false);

    const { startRecording, stopRecording, playReceivedAudio, stopPlayingAudio, isSourceActive } = useAudioStream();
    const [isRecording, setIsRecording] = React.useState(false);

    const[userMessage, setUserMessage] = React.useState("");
    const[chatHistory, setChatHistory] = React.useState(null);
    const[newSession, setNewSession] = React.useState(null);

    const [currentReportId, setCurrentReportId] = React.useState(null);
    const [checkpointData, setCheckpointData] = React.useState(null);
    const [hitlLoading, setHitlLoading] = React.useState(false);
    const pollingRef = React.useRef(null);

    React.useEffect(() => {
        const createSession = async() => {
            createNewSession();
        }
        createSession();

        return () => {
            stopPolling();
            const cleanup = async () => {
                console.log("Cleaning up chat session");
                // updateChatSession(); // Closing the chat session
              };
            cleanup(); // Call the async cleanup function

        };
    }, []);

    const createNewSession = async() => {
        
        newSessionRequest.subReference = "report-instructions-chat";

        setLoading(true);
        const response = await createReportChatSession(newSessionRequest, loginUser.jwtToken);
        setLoading(false);

        if (!response) {
            swal({ title: "Error", text: "Failed to create new session", icon: "error", button: "OK" });
            return;
        }

        setNewSession(response.chatSession);
        completionsRequest.sessionId = response.chatSession.id;

        if(response.chatSession.chatSessionData && response.chatSession.chatSessionData.length > 0) {
            setChatHistory(response.chatSession);
        }
    
    };

    const stopPolling = () => {
        if (pollingRef.current) {
            clearInterval(pollingRef.current);
            pollingRef.current = null;
        }
    };

    const startPolling = (reportId) => {
        stopPolling();
        pollingRef.current = setInterval(async () => {
            const status = await getPipelineStatus(reportId, loginUser.jwtToken);
            console.log("status: ", status);
            if (!status) return;

            if (status.status === 'WAITING_FOR_INPUT') {
                stopPolling();
                setCheckpointData(status);
            } else if (status.status === 'COMPLETED') {
                stopPolling();
                setCheckpointData(null);
                swal({ title: "Report Ready!", text: "Your report has been generated and sent to your email.", icon: "success", button: "OK" });
            } else if (status.status === 'FAILED') {
                stopPolling();
                setCheckpointData(null);
                swal({ title: "Report Failed", text: "Report generation encountered an error.", icon: "error", button: "OK" });
            }
            // else RUNNING: continue polling
        }, 4000);
    };

    const handleHitlResolved = (approved) => {
        setCheckpointData(null);
        if (currentReportId) {
            startPolling(currentReportId);
        }
    };

    const generateReport = async() => {
        setLoading(true);
        const response = await executeReportPipeline(reportRequest, loginUser.jwtToken);
        setLoading(false);

        if (!response || !response.reportId) {
            swal({ title: "Error", text: "Failed to start report generation", icon: "error", button: "OK" });
            return;
        }

        setCurrentReportId(response.reportId);
        swal({
            title: "Report Generation Started",
            text: "The report is being generated. You can track progress below.",
            icon: "success",
            button: "OK",
            timer: 3000,
        });

        startPolling(response.reportId);
    };

    const userMessageChange = async(e) => {
        setUserMessage(e.target.value);
        completionsRequest.userMessage = e.target.value;
        reportRequest.userRequest = e.target.value;
    };

    const getChatCopletion = async() => {

        completionsRequest.topicId = props.location?.state?.topicId;
        setUserMessage("");
        
        setChatLoading(true);
        const response = await manageReportChatFlow(completionsRequest, loginUser.jwtToken);
        setChatLoading(false);

        cleanAudioMessage();

        if (!response) {
            swal({ title: "Error", text: "Failed to get chat completion", icon: "error", button: "OK" });
            return;
        }

        setChatHistory(response.chatSession);

        if(response.base64AudioData){
            playReceivedAudio(response.base64AudioData);
        }

    };

    const updateChatSession = async() => {

        const updateSessionRequest ={
            sessionId: completionsRequest.sessionId ,
            reference: "grace_system_final",
            userMessage: "Conversation completed",
        }

        setLoading(true);
        const response = await updateChatSessionSystemPrompts(updateSessionRequest, loginUser.jwtToken);
        setLoading(false);

        if (!response) {
            swal({ title: "Error", text: "Failed to update chat session", icon: "error", button: "OK" });
            return;
        }

        // setChatHistory(response);
    }

    //Trigger scroll when chatHistory changes
    const chatEndRef = React.useRef(null);

    const scrollToBottom = () => {
        chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    React.useEffect(() => {
        scrollToBottom();
    }, [chatHistory]);

    const handleStartRecording = async () => {
        setIsPlaying(false);
        setIsRecording(true);
        await startRecording();
    };
    
    const handleStopRecording = async () => {
        setIsPlaying(true);
        setIsRecording(false);
        const audioRequest = await stopRecording();

        console.log(audioRequest);

        completionsRequest.audioData = audioRequest.audioData;
        completionsRequest.sampleRate = audioRequest.sampleRate;
        completionsRequest.isSpeechRequest = true;


        
        getChatCopletion();
        
    };

    const cleanAudioMessage = () => {
        completionsRequest.audioData = null;
        completionsRequest.sampleRate = null;
        completionsRequest.isSpeechRequest = false;
    };

    const handleStopPlayingAudio = async () => {
        stopPlayingAudio();
        setIsPlaying(false);
    };

    const[isPlaying, setIsPlaying] = React.useState(false);

    React.useEffect(() => {
        // Update state whenever sourceRef.current changes
        console.log("isSourceActive: ", isSourceActive);
        if(isSourceActive === false){
            setIsPlaying(false);
        }
    }, [isSourceActive]);

    //Functions for buffered loader
    const [progress, setProgress] = React.useState(0);
    const [buffer, setBuffer] = React.useState(10);
  
    const progressRef = React.useRef(() => {});
    React.useEffect(() => {
        progressRef.current = () => {
          if (progress === 100) {
            setProgress(0);
            setBuffer(10);
          } else {
            setProgress((prevProgress) => prevProgress + 1);
            if (buffer < 100 && progress % 5 === 0) {
              const newBuffer = buffer + 1 + Math.random() * 10;
              setBuffer(newBuffer > 100 ? 100 : newBuffer);
            }
          }
        };
      }, [progress, buffer]); // Depend on progress and buffer
      
      React.useEffect(() => {
        if (!chatLoading) {
          // Reset progress and buffer when chatLoading is false
          setProgress(0);
          setBuffer(10);
          return; // Stop execution if chatLoading is false
        }
      
        const timer = setInterval(() => {
          progressRef.current();
        }, 100);
      
        return () => {
          clearInterval(timer);
        };
      }, [chatLoading]);

    return (
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%", height: "100%" }}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: {xs: "90%", sm: "90%", md: "95%"}, height: "90%", textAlign: "center", marginTop: { xs: "1.3rem", sm: 0 }}}>
                {loading ? <CustomLoader /> :
                    <Grid container direction="row" sx={{justifyContent: "center"}}>
                        <Grid item xs={12} sx={{display: "flex", justifyContent: "start", mt: "5.3rem", textAlign: "left"}}>
                            <Typography>
                                <Box component="span" sx={{ fontSize: {xs: "1.7rem", sm: "2rem"}, fontWeight: "bold" }}>{`Hello ${loginUser.firstName}!`}</Box> 
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sx={{display: "flex", justifyContent: "center", mt:"1rem"}}>
                            <Grid container
                                sx={{
                                    display: "flex", 
                                    justifyContent: "center",
                                    padding: {xs: "0.8rem", sm: "1rem"},
                                    borderRadius: "0.75rem",
                                    backgroundColor: "#f9f9f9",
                                    gap: {xs: "0.5rem", sm: "1.8rem"},
                                }}
                            >
                                {/*Chat section*/}
                                <Grid item xs={12} sx={{display: "flex", justifyContent: "center", padding: "1rem", borderRadius: "0.75rem", backgroundColor: "white"}}>
                                    <Grid container sx={{height: { xs: '80vh', sm: '80vh', md: '80vh'}, overflowY: 'auto', marginTop: {sx: "1rem", sm: "1rem", md: "3rem"}}}>
                                        <Grid item xs={3} sm={3} sx={{ display: "flex", justifyContent: "start" }}>
                                            {/* <Avatar sx={{ bgcolor: Colors.primary, mr: "2%"}}>G</Avatar> */}
                                            <Avatar sx={{ bgcolor: Colors.primary, mr: "2%", width: {xs: "3rem", sm: "4rem"}, height: {xs: "3rem", sm: "4rem"}}}>
                                                <PersonIcon sx={{fontSize: {xs: "2rem", sm: "3rem"}, color: "white"}}/>
                                            </Avatar>
                                        </Grid>
                                        <Grid item xs={9} sm={9} sx={{ display: "flex", justifyContent: "start",  height: { xs: "65px", sm: "100px" },}}>
                                            <Grid container sx={{display: "flex", justifyContent: "start", width: {xs: "100%", sm: "85%"}, gap: 0, rowGap: 0}}>
                                                <Grid item xs={12} sx={{textAlign: "left"}}>
                                                    <Grid container direction="column">
                                                        <Grid item sx={{display: "flex", justifyContent: "start"}}>
                                                            <Typography variant="body1" sx={{ color: "black", fontWeight: "bold", fontSize: {xs: "1.1rem", sm: "1.4rem"} }}>{"Data Love AI"}</Typography>
                                                        </Grid>
                                                        <Grid item sx={{display: "flex", justifyContent: "start"}}>
                                                            <Typography variant="body2" sx={{ color: "black", fontSize: {xs: "0.8rem", sm: "1rem"} }}>{"Your personal, AI Data Officer."}</Typography>
                                                        </Grid>
                                                    </Grid>     
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {chatHistory && chatHistory.chatSessionData &&
                                            <Grid item xs={12} sx={{mt: {xs: "1.5rem", sm: 0}}}>
                                                <List sx={{ width: "95%", marginTop: { xs: "3rem", sm: "2rem", md: "2rem" } }}>
                                                {chatHistory.chatSessionData
                                                    .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp)) // Sort by startTime (latest first)
                                                    .map((data, index) => (
                                                        <Grid key={data.id} container spacing={1}>
                                                            {data.userMessage &&
                                                                <Grid item xs={12} sx={{ display: "flex", justifyContent: "end", textAlign: "end" }}>
                                                                    <ListItem disablePadding sx={{ width: {xs: "75%", sm: "60%"}, marginBottom: "1.5rem", bgcolor: "#d0ebff", borderRadius: "16px", boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)", padding: "0.75rem 1rem"}}>
                                                                        {/* <Typography variant="body2" sx={{ fcolor: "black" }}>{data.userMessage}</Typography> */}
                                                                        <Typography variant="body2" sx={{ color: "black" }}>
                                                                            {data.userMessage.split(/\r?\n/).map((line, index) => (
                                                                                <React.Fragment key={index}>
                                                                                    {line}
                                                                                    <br />
                                                                                </React.Fragment>
                                                                            ))}
                                                                        </Typography>
                                                                    </ListItem>
                                                                </Grid>
                                                            }
                                                            <Grid item xs={12} sx={{ display: "flex", justifyContent: "start", textAlign: "start" }}>
                                                                <ListItem disablePadding sx={{ width: {xs: "90%", sm: "65%"}, marginBottom: "1.5rem", bgcolor: "grey.200", borderRadius: "16px", boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)", padding: "0.75rem 1rem" }}>
                                                                    {/* <Typography variant="body2" sx={{ color: "black" }}>{data.assistantMessage}</Typography> */}
                                                                    <Typography variant="body2" sx={{ color: "black" }}>
                                                                        {data.assistantMessage.split(/\r?\n/).map((line, index) => (
                                                                            <React.Fragment key={index}>
                                                                                {line}
                                                                                <br />
                                                                            </React.Fragment>
                                                                        ))}
                                                                    </Typography>
                                                                </ListItem>
                                                            </Grid>
                                                        </Grid>
                                                        
                                                    ))}
                                                    {/* Scroll anchor */}
                                                    <div ref={chatEndRef} />
                                                </List>
                                            </Grid>
                                        }
                                        {checkpointData && (
                                            <Grid item xs={12} sx={{ px: 1, mb: 2 }}>
                                                <HitlReviewPanel
                                                    checkpoint={checkpointData}
                                                    jwtToken={loginUser.jwtToken}
                                                    onResolved={handleHitlResolved}
                                                />
                                            </Grid>
                                        )}
                                        {currentReportId && !checkpointData && !chatLoading && (
                                            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                                                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                                    Tracking report generation...
                                                </Typography>
                                            </Grid>
                                        )}
                                        {chatLoading ?
                                            <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", width: "100%"}}>
                                                {/* <CircularProgress />  */}
                                                <Box sx={{ width: {xs: "50%", sm: "30%"} }}>
                                                    <LinearProgress variant="buffer" value={progress} valueBuffer={buffer} />
                                                </Box>
                                            </Grid>
                                        :
                                        <>
                                            <Grid item xs={9} sm={8} md={8} sx={{display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "2rem"}}>
                                                <TextField
                                                    value={userMessage}
                                                    onChange={(e) => userMessageChange(e)}
                                                    placeholder="Type your message or click microphone to speak..."
                                                    multiline
                                                    minRows={1}
                                                    maxRows={5} // Adjust to set maximum height
                                                    fullWidth
                                                    sx={{
                                                            width: {xs:"95%", sm: "85%"},
                                                        '& .MuiInputBase-root': {
                                                            borderRadius: '16px', // Optional: Add rounded edges
                                                        },
                                                        '& .MuiInputBase-input': {
                                                            fontSize: { xs: "0.8rem", sm: "1rem", md: "1rem" }, // Input text font size
                                                        },
                                                        '& .MuiInputBase-input::placeholder': {
                                                            fontSize: { xs: "0.8rem", sm: "1rem", md: "1rem" }, // Placeholder text font size
                                                        },
                                                        
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter' && !e.shiftKey) {
                                                            e.preventDefault(); // Prevents new line on Enter key
                                                            getChatCopletion(); // Calls the function when Enter is pressed
                                                        }
                                                    }}
                                                />
                                            </Grid>
                                            {false &&
                                                <>
                                                {userMessage &&
                                                <Grid item xs={3} sm={4} md={4} sx={{display: "flex", alignItems: "center", justifyContent: {xs:"center", sm: "start"}, marginBottom: "2rem"}}>
                                                    <Button
                                                        variant="contained"
                                                        sx={{backgroundColor: Colors.primary, color: Colors.white, borderRadius: '16px'}}
                                                        onClick={getChatCopletion}
                                                    >
                                                        <PlayCircleFilledIcon sx={{fontSize: {xs: "1.5rem", sm: "2rem"}}}/>
                                                    </Button>
                                                </Grid>
                                                }
                                                {!userMessage && isRecording === false && isPlaying===false &&
                                                <Grid item xs={3} sm={4} md={4} sx={{display: "flex", alignItems: "center", justifyContent: {xs:"center", sm: "start"}, marginBottom: "2rem"}}>
                                                    <Button
                                                        variant="contained"
                                                        sx={{backgroundColor: `${Colors.primary} !important`, color: Colors.white, borderRadius: '16px'}}
                                                        onClick={handleStartRecording}
                                                    >
                                                        <MicIcon sx={{fontSize: {xs: "1.5rem", sm: "2rem"}}}/>
                                                    </Button>
                                                </Grid>
                                                }
                                                {!userMessage && isRecording === true &&
                                                <Grid item xs={3} sm={4} md={4} sx={{display: "flex", alignItems: "center", justifyContent: {xs:"center", sm: "start"}, marginBottom: "2rem"}}>
                                                    <Button
                                                        variant="contained"
                                                        sx={{backgroundColor: `red !important`, color: Colors.white, borderRadius: '16px'}}
                                                        onClick={handleStopRecording}
                                                    >
                                                        <MicIcon sx={{fontSize: {xs: "1.5rem", sm: "2rem"}}}/>
                                                    </Button>
                                                </Grid>
                                                }
                                                {isPlaying===true &&
                                                <Grid item xs={3} sm={4} md={4} sx={{display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "2rem"}}>
                                                    <Grid container sx={{display: "flex", justifyContent: "center", alignItems: "center", mt: {xs:0, sm: "1.2rem"}}}>
                                                        <Grid item xs={12} sm={4} md={4} sx={{display: "flex", alignItems: "center", justifyContent: "center", marginBottom: {xs: "0.5rem", sm: "2rem"}}}>
                                                            <Button
                                                                variant="contained"
                                                                sx={{backgroundColor: `${Colors.primary} !important`, color: Colors.white, borderRadius: '16px'}}
                                                                onClick={handleStartRecording}
                                                            >
                                                                <MicIcon sx={{fontSize: {xs: "1.2rem", sm: "2rem"}}}/>
                                                            </Button>
                                                        </Grid>
                                                        <Grid item xs={12} sm={8} md={8} sx={{display: "flex", alignItems: "center", justifyContent: {xs:"center", sm: "start"}, marginBottom: {xs: 0, sm: "2rem"}}}>
                                                            <Button
                                                                variant="contained"
                                                                sx={{backgroundColor: `red !important`, color: Colors.white, borderRadius: '16px'}}
                                                                onClick={handleStopPlayingAudio}
                                                            >
                                                                <StopIcon sx={{fontSize: {xs: "1.2rem", sm: "2rem"}}}/>
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                }
                                                </>
                                            }
                                            <Grid item xs={12} sx={{display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "2rem", marginTop: "1rem"}}>
                                                <Button
                                                    variant="contained"
                                                    startIcon={<AssessmentIcon />}
                                                    sx={{
                                                        backgroundColor: Colors.primary, 
                                                        color: Colors.white, 
                                                        borderRadius: '16px',
                                                        padding: {xs: "0.5rem 1.5rem", sm: "0.75rem 2rem"},
                                                        fontSize: {xs: "0.9rem", sm: "1rem"},
                                                        textTransform: "none",
                                                        '&:hover': {
                                                            backgroundColor: Colors.primary,
                                                            opacity: 0.9
                                                        }
                                                    }}
                                                    onClick={generateReport}
                                                >
                                                    Generate Report
                                                </Button>
                                            </Grid>
                                        </>
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                }
            </Box>
        </Box>
    );
}
